import { FC } from 'react';
import futureSelvesBanner from './assets/future_selves_banner.svg';

interface FutureSelfIntroPanelProps {
  onNoThanks: () => void;
  onAppearance: () => void;
}

export const FutureSelfIntroPanel: FC<FutureSelfIntroPanelProps> = ({ onNoThanks, onAppearance }) => {
  return (
    <div className="tw-flex-1 tw-flex tw-flex-col tw-px-8 tw-pt-6 tw-pb-5 tw-min-h-0">
      <div className="tw-flex-1 tw-min-h-0 tw-flex tw-flex-col tw-items-center tw-text-center tw-gap-4 tw-justify-center">
        <img
          src={futureSelvesBanner}
          alt="Future Selves banner"
          className="tw-w-full tw-max-w-3xl tw-max-h-[34vh] tw-h-auto tw-object-contain tw-rounded-2xl"
        />

        <div className="tw-max-w-3xl tw-space-y-1.5">
          <h2 className="tw-text-3xl tw-font-bold tw-text-gray-900">Make a Future Self Avatar</h2>
          <p className="tw-text-base tw-text-gray-700">
            Tell us what you&apos;re into, and we&apos;ll generate some possible future versions of you.
          </p>
        </div>

        <div className="tw-max-w-3xl tw-w-full tw-rounded-2xl tw-border tw-border-amber-300 tw-bg-amber-50 tw-p-3 tw-flex tw-items-center tw-justify-center tw-gap-3 tw-flex-wrap">
          <span className="tw-inline-flex tw-items-center tw-rounded-full tw-bg-yellow-400 tw-text-yellow-950 tw-font-semibold tw-text-xs tw-px-3 tw-py-1">
            Beta Feature
          </span>
          <span className="tw-text-sm tw-font-medium tw-text-amber-900">
            You&apos;re one of the first to try this! We hope you like it!
          </span>
        </div>
      </div>

      <div className="tw-pt-4 tw-mt-2 tw-border-t tw-border-gray-200 tw-flex tw-items-center tw-justify-center tw-gap-3">
        <button
          type="button"
          onClick={onNoThanks}
          className="tw-rounded-full tw-px-6 tw-py-2 tw-text-sm tw-bg-white tw-text-gray-700 tw-border tw-border-gray-300 hover:tw-bg-gray-50"
        >
          no thanks
        </button>

        <button
          type="button"
          onClick={onAppearance}
          className="tw-rounded-full tw-px-6 tw-py-2 tw-text-sm tw-bg-blue-600 tw-text-white hover:tw-bg-blue-700"
        >
          Let&apos;s Go!
        </button>
      </div>
    </div>
  );
};

export default FutureSelfIntroPanel;
